import React, { PropsWithChildren } from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { Spin } from 'antd';
import { LocalizationLoader } from '../translate';

const ExtensionContext = React.createContext<{
	piletApi: PiletApi;
}>({} as any);

export interface ExtensionsContextProviderProps extends PropsWithChildren {
	piletApi: PiletApi;
}

export const ExtensionsContextProvider: React.FC<ExtensionsContextProviderProps> = ({
	children,
	piletApi,
}) => {
	return (
		<ExtensionContext.Provider value={{ piletApi }}>
			<LocalizationLoader loadingElement={<Spin />}>{() => children}</LocalizationLoader>
		</ExtensionContext.Provider>
	);
};

export function useExtensionContext() {
	return React.useContext(ExtensionContext);
}
